import React from "react";

interface CopyIconProps {
  size?: number;
  color?: string;
}

export default function CopyIcon({
  size = 20,
  color = "#79808A",
}: CopyIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3333 6H7.66667C6.74619 6 6 6.72323 6 7.61538V18.3846C6 19.2768 6.74619 20 7.66667 20H14.3333C15.2538 20 16 19.2768 16 18.3846V7.61538C16 6.72323 15.2538 6 14.3333 6Z"
        stroke={color}
        stroke-width="1.2"
      />
      <path
        d="M8 5.61538C8 5.18696 8.17559 4.77608 8.48816 4.47314C8.80072 4.17019 9.22464 4 9.66667 4H16.3333C16.7754 4 17.1993 4.17019 17.5118 4.47314C17.8244 4.77608 18 5.18696 18 5.61538V16.3846C18 16.813 17.8244 17.2239 17.5118 17.5269C17.1993 17.8298 16.7754 18 16.3333 18"
        stroke={color}
        stroke-width="1.2"
      />
    </svg>
  );
}
